import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import Loading from '#components/a/Loading'
import {useWissensportalData} from '#hooks/useWissensportalData'
import AzubiWithCourses from '#components/m/Wissensportal/AzubiWithCourses'
import {filterAzubiList} from './WissensportalHelper'
import WissensportalAusbilderTrainerHeaderWithFilter from '#components/o/Wissensportal/WissensportalAusbilderTrainerHeaderWithFilter'

function WissensportalAusbilderTrainerSingle({azubiId, setFilters, selectedFilters}) {
  const [azubiWithFilteredCoursesOfCurrentPage, setAzubiWithFilteredCoursesOfCurrentPage] = useState()

  const [isLoading, setIsLoading] = useState(true)
  const [azubiWithCourses, setAzubiWithCourses] = useState([])
  const [uniqueCourses, setUniqueCourses] = useState([])
  const [uniqueModules, setUniqueModules] = useState([])

  const filterCallback = filters => {
    setFilters(filters)
    const list = filterAzubiList(filters, [azubiWithCourses])
    if (list && list.length > 0) {
      setAzubiWithFilteredCoursesOfCurrentPage(list[0])
    }
  }

  const loadWissenportalData = async () => {
    setIsLoading(false)
    const {allAzubisWithCourses, uniqueCourses, uniqueModules} = await useWissensportalData([azubiId])
    if (allAzubisWithCourses && allAzubisWithCourses.length > 0) {
      setAzubiWithCourses(allAzubisWithCourses[0])
      const list = filterAzubiList(selectedFilters, [allAzubisWithCourses[0]])
      if (list && list.length > 0) {
        setAzubiWithFilteredCoursesOfCurrentPage(list[0])
      }
    }
    setUniqueCourses(uniqueCourses)
    setUniqueModules(uniqueModules)
  }

  useEffect(() => {
    loadWissenportalData()
  }, [])

  return (
    <div className="wissensportal">
      <WissensportalAusbilderTrainerHeaderWithFilter
        selectedFilters={selectedFilters}
        uniqueCourses={uniqueCourses}
        uniqueModules={uniqueModules}
        filterCallback={filterCallback}
      />
      {isLoading && <Loading />}
      <div className="wissensportal__content-wrapper wissensportal-ausbilder">
        {azubiWithFilteredCoursesOfCurrentPage && azubiWithFilteredCoursesOfCurrentPage.user && (
          <AzubiWithCourses
            key={azubiWithFilteredCoursesOfCurrentPage.user.id}
            user={azubiWithFilteredCoursesOfCurrentPage.user}
            courses={azubiWithFilteredCoursesOfCurrentPage.courses}
          />
        )}
      </div>
    </div>
  )
}

WissensportalAusbilderTrainerSingle.propTypes = {
  azubiId: PropTypes.number,
  setFilters: PropTypes.func,
  selectedFilters: PropTypes.object,
}

export default WissensportalAusbilderTrainerSingle
